import { isIos, isAndroid } from './platform';
import { RAF } from './raf';

interface IOnKeyboardUpOrDown {
  input?: HTMLInputElement | HTMLTextAreaElement;
  onKeyboardUp?: (keyboardH: number) => void;
  onKeyboardDown?: (keyboardH: number) => void;
}

// Monitor keyboard pop up hide
const _onKeyboardUpOrDown = ({
  onKeyboardUp,
  onKeyboardDown,
}: IOnKeyboardUpOrDown): void => {
  const WIH = window.innerHeight;
  // Not on the client side
  if (!(isIos || isAndroid)) {
    if (typeof onKeyboardUp === 'function') {
      onKeyboardUp(0);
    }
    if (typeof onKeyboardDown === 'function') {
      onKeyboardDown(0);
    }
    return;
  }
  // If it is the client side, you need to listen for the keyboard pop-up close event
  RAF((cancel?: VoidFunction) => {
    // If the keyboard pop-up close event is not monitored
    if (typeof cancel === 'function') {
      // Keyboard eject
      if (WIH > window.innerHeight) {
        if (typeof onKeyboardUp === 'function') {
          onKeyboardUp(WIH - window.innerHeight);
        }
        cancel();
      }
      // Keyboard put away
      if (WIH < window.innerHeight) {
        if (typeof onKeyboardDown === 'function') {
          if (isIos) {
            setTimeout(() => {
              onKeyboardDown(window.innerHeight - WIH);
            }, 80);
          } else {
            onKeyboardDown(window.innerHeight - WIH);
          }
        }
        cancel();
      }
    } else {
      if (typeof onKeyboardUp === 'function') {
        onKeyboardUp(0);
      }
      if (typeof onKeyboardDown === 'function') {
        onKeyboardDown(0);
      }
    }
  });
};

// Monitor keyboard pop up hide
export const onKeyboardUpOrDown = ({
  input,
  onKeyboardUp,
  onKeyboardDown,
}: IOnKeyboardUpOrDown): VoidFunction | void => {
  if (input) {
    const funcFocus = () => _onKeyboardUpOrDown({ onKeyboardUp });
    const funcBlur = () => _onKeyboardUpOrDown({ onKeyboardDown });
    input.addEventListener('focus', funcFocus, false);
    input.addEventListener('blur', funcBlur, false);
    return () => {
      input.removeEventListener('focus', funcFocus);
      input.removeEventListener('blur', funcBlur);
    };
  } else {
    _onKeyboardUpOrDown({ onKeyboardUp, onKeyboardDown });
  }
};
